import * as React from "react";
const SvgFiRrMoneyCoinTransfer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-money-coin-transfer_svg__a)">
      <path
        fill="#062147"
        d="M24.001 4c0 .5-.195.972-.55 1.326l-2.224 2.36a1 1 0 0 1-1.414.042 1 1 0 0 1-.042-1.414L21.01 5H12a7.008 7.008 0 0 0-6.78 8.75 1 1 0 0 1-1.937.5A9 9 0 0 1 2.998 12C3 7.038 7.038 3 12 3h9.011l-1.238-1.314A1 1 0 0 1 21.228.314l2.244 2.382c.334.332.53.803.53 1.304m-4.503 5.032a1 1 0 0 0-.718 1.217c.146.566.22 1.156.22 1.75 0 3.86-3.14 7-7 7H2.99l1.238-1.313a1.001 1.001 0 0 0-1.456-1.372L.55 18.674c-.73.73-.73 1.919-.02 2.628l2.243 2.381a.997.997 0 0 0 1.414.042 1 1 0 0 0 .042-1.414L2.99 20.998H12c4.963 0 9-4.038 9-9 0-.764-.096-1.52-.284-2.25a1 1 0 0 0-1.218-.717zM12 6.7c-.44 0-.8.359-.8.8v.7h-.327a2.174 2.174 0 0 0-2.135 2.59c.16.852.887 1.55 1.812 1.734l2.688.538a.575.575 0 0 1-.112 1.137h-2.204a.7.7 0 0 1-.564-.286c-.142-.194-.433-.213-.552-.213a.8.8 0 0 0-.732.476.76.76 0 0 0 .122.84 2.3 2.3 0 0 0 1.727.784h.278v.7a.8.8 0 0 0 1.6 0v-.7h.326c.647 0 1.257-.287 1.673-.787a2.19 2.19 0 0 0 .463-1.803c-.16-.854-.889-1.552-1.812-1.735l-2.688-.54a.574.574 0 0 1 .112-1.136h2.204c.223 0 .434.108.564.287.142.194.433.213.552.213a.8.8 0 0 0 .732-.475.765.765 0 0 0-.12-.841 2.3 2.3 0 0 0-1.729-.782h-.277v-.7a.8.8 0 0 0-.8-.8z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-money-coin-transfer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMoneyCoinTransfer;
